import * as Rx from 'rxjs';
import type IProfile from 'v2/interfaces/profile';
import type { IModalFiscalForm } from 'v2/interfaces/terms';

import apiService from './api';
import type { ApiService } from './api';

/**
 * Service responsible for controlling `Profile` component.
 *
 * @class ProfileService
 */
class ProfileService {
  private profile$ = new Rx.BehaviorSubject<IProfile>(null);

  constructor(private apiService: ApiService) {}

  public get(): Rx.Observable<IProfile> {
    return this.profile$;
  }

  public set(profile: IProfile): void {
    this.profile$.next(profile);
  }
  /**
   * @method updateProfile
   * @return {Observable}
   */
  public updateProfile = (data: IModalFiscalForm) => {
    const model = {
      ...data,
      terms_accepted: data.fiscal_responsibility && data.producer_affiliate_terms ? 1 : 0,
      fiscal_responsibility: data.fiscal_responsibility ? 1 : 0,
      producer_affiliate_terms: data.producer_affiliate_terms ? 1 : 0
    };

    return this.apiService.put('profile', model);
  };

  public load(): void {
    apiService.get('/profile').subscribe(data => this.profile$.next(data.data));
  }
}

const ProfileFactory = new ProfileService(apiService);
export const profileFactory = ProfileFactory;
